<template>
  <div class="l28-lht" style="background: linear-gradient(#7a58eb, #6f95fa); min-height: 1000px;">
    <div style="background: #fff;"> 
      <div style="width:1400px; margin:0 auto; padding:10px 0;">
        <PageHeader style="margin:10px 0 0 0;"/>
        <div style="padding: 20px 30px;">
          日期：<a-date-picker style="width:210px" :allowClear="false" v-model="ds" @change="(date, dateStr)=>getData(dateStr)" :disabled-date="disabledRangeDate" />
          <span style="margin: 0 0 0 20px">巡回赛：</span>
          <a-select style="width: 300px" v-model="tour_id">
            <a-select-option :value="tour.id" :label="tour.name" v-for="tour in tours" :key="tour.id"><a-tag color="blue">{{tour.ts}}</a-tag>{{tour.name}}</a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <div style="width:1400px; margin:0 auto; padding:10px 0; color:#fff;">
    </div>
    <div class="l28_ctrl_container_new" v-if="tour">
      <div class="l28_tour_maps-new">
        <div :class="`l28-groups-new l28-groups-phase${phase.id}`" v-for="phase in tour.phase_list" :key="phase.id">
          <div class="l28_tour_phase_name">{{phase.name}}</div>
          <div class="l28_tour_phase_group">
            <div class="l28_tour_group_new"
                v-for="group in phase.groups"
                :key="`${tour.id}_${phase.id}_${group.id}`">
              <Group 
                :name="group.name" 
                :players="group.players" 
                :is_final="phase.id===7"
              >
              </Group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="l28_ctrl_empty">暂无比赛</div>
  </div>
</template>
<script>
import PageHeader from '@/components/game/pageheader.vue';
import { DatePicker, Select, Tag } from 'ant-design-vue';
import Vue from 'vue';
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Tag)

import Chart from '@/components/common/chart/chart.vue';
import DataTable from '@/components/common/datatable.vue';
import Searcher from '@/components/common/search/searcher.vue';
import { ctrlMixin } from '@/utils/ctrlMixin.js';
import moment from "moment";
import Group from './l28-lht-group.vue';
const GROUP_NAMES = ['Finalists', 'Half 1', 'Half 2', '1/4', '2/4', '3/4', '4/4', '1/8', '2/8', '3/8', '4/8', '5/8', '6/8', '7/8', '8/8', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K']

const GROUP_NAMES_NEW = {
  '7-1':'Finalists',
  '6-1': 'Half 1',
  '6-2': 'Half 2',
}

const PHASE_NAMES = {
  '7': 'FINAL',
  '6': 'SEMI',
  '5': 'QUARTERS',
  '-': 'QUALIFIER'
}

export default {
  mixins: [ctrlMixin],
  name:'l28-lht',
  props: ['parent', 'name'],
  components: {
    DataTable,
    Chart,
    Searcher,
    PageHeader,
    Group
  },
  mounted(){
    this.ds = moment()
    this.getData(this.ds.format('YYYY-MM-DD'))
  },
  data() {
    return {
      ds: moment(),
      tour_id: null,
      datas: [],
      GROUP_NAMES
    }
  },
  computed: {
    tours() {
      const tour_dict = {}
      let min_phase = 7
      const _d = []
      this.datas.forEach(row=>{
          if(row.tour_play_id==1002972) {
            _d.push(row)
          }
        if(!row.phase_group) {
          row.phase_group = row.room_id%10000
        }
        row.current_phase = typeof(row.current_phase)=='string'?parseInt(row.current_phase):row.current_phase
        if(row.current_phase < min_phase) {
          min_phase = row.current_phase
        }
        if(!tour_dict[row.tour_play_id]) {
          tour_dict[row.tour_play_id] = {
            id: row.tour_play_id,
            name: row.tour_name,
            time: row.ts,
            groups: {},
            phases: {},
            clone: row.tour_id != row.tour_play_id
          }
        }
        if(!tour_dict[row.tour_play_id].phases[row.current_phase]) {
          tour_dict[row.tour_play_id].phases[row.current_phase] = {}
        }
        if(row.ts < tour_dict[row.tour_play_id].time) {
          tour_dict[row.tour_id].time = row.ts
        }

        if(!tour_dict[row.tour_play_id].phases[row.current_phase][row.phase_group]) {
          tour_dict[row.tour_play_id].phases[row.current_phase][row.phase_group] = new Array(9)
        }
        if(!tour_dict[row.tour_play_id].phases[row.current_phase][row.phase_group][row.group_rank===0?8:row.group_rank-1]) {
          tour_dict[row.tour_play_id].phases[row.current_phase][row.phase_group][row.group_rank===0?8:row.group_rank-1] = []
        }
        tour_dict[row.tour_play_id].phases[row.current_phase][row.phase_group][row.group_rank===0?8:row.group_rank-1].push(row)
      })
      const sorted_tour = Object.values(tour_dict).sort((a, b)=>{
        const atime = a.time
        const btime = b.time
        return atime < btime ? -1 : atime===btime? a.tour_id<b.tour_id?-1:a.tour_id===b.tour_id?0:1:1
      }).map(tour=>{
        min_phase = Object.keys(tour.phases).map(p=>parseInt(p)).sort((a,b)=>a-b)[0]
        if(tour.time) {
          const t = tour.time.split(' ')[1].split(':')
          t[1] = parseInt(t[1]) - parseInt(t[1])%10
          tour.ts = `${t[0]}:${t[1]<10?'0':''}${t[1]}`
          const _phase_list = new Array(7-min_phase+1)
          
          let teamn = 1
          for(let pi=0; pi<_phase_list.length; pi++) {
            let phase_id = 7 - pi
            const _phase_groups = []
            const _group_num = tour.phases[phase_id]?Object.keys(tour.phases[phase_id]).length:teamn
            for(let group_id=1; group_id<=_group_num; group_id++) {
              _phase_groups.push({id: group_id, name: GROUP_NAMES_NEW[`${phase_id}-${group_id}`] || `${group_id}/${_group_num}`, players: tour.phases[phase_id] && tour.phases[phase_id][group_id]?tour.phases[phase_id][group_id]:[]})
            }
            teamn*=2
            let name = ''
            if(PHASE_NAMES[phase_id]) {
              name = PHASE_NAMES[phase_id]
            }
            else if(pi === _phase_list.length -1 ) {
              name = PHASE_NAMES['-']
            }
            else {
              name = `ROUND ${_phase_list.length-pi-1}`
            }
            _phase_list[pi]={id:phase_id, name:name, groups:_phase_groups.sort((a, b)=>a.id-b.id)}
          }
          tour.phase_list = _phase_list.sort((a, b)=>b.id-a.id)
          return tour 
        }
      })
      if(sorted_tour.length > 0) {
        this.tour_id = sorted_tour[sorted_tour.length - 1].id
      }
      else {
        this.tour_id = undefined
      }
      return sorted_tour
    },
    tour() {
      return this.tours.find(tour=>tour.id == this.tour_id)
    }
  },
  methods: {
    disabledRangeDate(current) {
      return current && (current<moment('2023-09-14').endOf('day') || current > moment().endOf('day'));
    },
    // 获取页面数据
    getData(ds) {
      if(ds<='2024-11-12') {
        return
      }
      this.loading = true
      this.$service.query(this.$route.query.id, {ds}).then((data)=>{
        this.datas = data[0]
        this.loading = false
      }).catch((data)=> {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="less">
.l28-lht {
  .page_header {
    border-bottom: none;
    .page_desc {
      padding-top:5px;
      padding-bottom:5px;
    }
  }
}
</style>
<style lang="less" scoped>

.l28_ctrl_container_new {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  font-family: "Source Han Sans SC", "Source Han Sans CN", sans-apple-system, "Noto Sans", "Helvetica Neue", Helvetica, "Nimbus Sans L", Arial, "Liberation Sans", "PingFang SC", "Hiragino Sans GB", "Noto Sans CJK SC",  "Microsoft YaHei", "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti", SimHei, "WenQuanYi Zen Hei Sharp", sans-serif;
  

  .l28_tour_names {
    position: relative;
    width: 140px;
    height: 100%;
    float: left;
    > div {
      position: absolute;
      color: #fff;
      font-weight: bold;
      font-size: 20px;
      &:nth-child(1) {
        top: 1260px;
      }
      &:nth-child(2) {
        top: 885px;
      }
      &:nth-child(3) {
        top: 630px;
      }
      &:nth-child(4) {
        top: 365px;
      }
      &:nth-child(5) {
        top: 105px;
      }
    }
  }
  .l28-groups-new {
    margin: 0px auto;
    position: relative;
    min-height: 100px;
    .l28_tour_phase_name {
      position: absolute;
      left: 20px;
      top: 40px;
      color: #fff;
      font-weight: bold;
      font-size: 20px;
    }
    .l28_tour_phase_group {
      max-width: 1300px;
      margin: 0px auto;
      position: relative;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      padding: 10px;
      .l28_tour_group_new {
        position: relative;
        margin: 5px;
        display: inline;
      }
    }
    &:nth-child(-n+4) {
      .l28_tour_phase_group {
        margin: 10px auto;
      }
      .l28_tour_group_new {
        .l28_tour_group {
          &:before {
            position: absolute;
            content: ' ';
            height: 20px;
            width: 2px;
            background: #fff;
            top: -20px;
            left: 72.5px;
          }
          &:after {
            position: absolute;
            content: ' ';
            height: 2px;
            width: 77.5px;
            background: #fff;
            top: -20px;
            left: 72.5px;
          }
        }
        &:before {
          position: absolute;
          content: ' ';
          height: 20px;
          width: 2px;
          background: #fff;
          bottom: -20px;
          left: 72.5px;
        }
        &:nth-child(even) {
          .l28_tour_group {
            &:after {
              left: auto;
              right: 72.5px;
            }
          }
        }
      }
    }
    &:nth-child(1) {
      .l28_tour_group {
        &:before {
          display: none;
        }
        &:after {
          display: none;
        }
      }
    }
    &:nth-child(2) {
      .l28_tour_group_new {
        margin: 5px 235.5px;
        .l28_tour_group {
          &:after {
            width: 312.5px;
          }
        }
      }
    }
    &:nth-child(3) {
      .l28_tour_group_new {
        margin: 5px 82.5px;
        .l28_tour_group {
          &:after {
            width: 155px;
          }
        }
      }
    }
    &:nth-child(4) {
      .l28_tour_group_new {
        &:before {
          display: none;
        }
      }
    }
    &:nth-child(5) {
      background: rgba(0, 0, 0, 0.1);
    }
    &:nth-child(6) {
      background: rgba(0, 0, 0, 0.2);
    }
    &:nth-child(7) {
      background: rgba(0, 0, 0, 0.3);
    }
    &:nth-last-child(1) {
      .l28_tour_group_new {
        &:before {
          display: none;
        }
      }
      .l28_tour_group {
        &:before {
          display: none;
        }
        &:after {
          display: none;
        }
      }
    }
    h2 {
      font-size: 18px;
      color: #5877ff;
      font-weight: bold;
    }
    .horizontal-line {
      position: absolute;
      width: 100px;
      height: 2px;
      background: #fff;
      top: -20px;
      left: 67px;
    }
    .vertical-line {
      position: absolute;
      width: 2px;
      height: 20px;
      background: #fff;
      top: 220px;
      left: 67px;
    }
  }

  .groups-qualifier {
    position: relative;
    width: 100%;
    top: 1040px;
    left: 0px;
    &::before {
      position: absolute;
      content: ' ';
      width: 100%;
      height: 500px;
      border: 2px solid #ddd;
      top: -15px;
      left: -15px;
      background: #5789f2;
    }
  }

  .groups-round-1 {
    top: 780px;
    left: 0px;
    .l28-groups-lines {
      top: 220px;
    }
  }
  .groups-quarters {
    top: 520px;
    left: 80px;
  }
  .groups-semi {
    top: 260px;
    left: 235px;
  }
  .groups-final {
    top: 0px;
    left: 550px;
  }
}
.l28_ctrl_empty {
  color: #fff;
  font-size: 20px;
  text-align: center;
  padding:150px 0;
}
</style>